import isIP from "validator/es/lib/isIP";

const dev = {
  apiBaseUrl: window["vnptEConferencePortalApiBaseUrl"] ||
    (isIP(location.hostname) ? "http://123.30.127.133:8608/api/v1" : "https://gomesainterk06.vnpt.vn/api/v1"),
  // apiBaseUrl:"https://localhost:44332/api/v1",
  appBaseUrl: "/app"
};

export default dev;
